export const LoginModais = {
  alterarSenha: 'alterarSenha',
};
